import React, { useContext, useEffect, useState } from 'react';
import { shortHeaders, shortFields, mappingStage } from './utils';
import axios from 'axios';
import UserContext from '../../../../contexts/UserContext';
import detailsIcon from '../../../../assets/orders/vector.svg';
import { format } from 'date-fns';
import OrdersContext from '../../../../contexts/OrdersContext';
import ModalContext from '../../../../contexts/ModalContext';
import LoadingComponent from '../../../../components/LoadingComponent'; // Importa o LoadingComponent
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from '../../../../components/table-style';

interface Order {
  Id: number
  OriginDealId: number
  StageName: string
  CreateDate: string
  Amount: number
  Title?: string // Adicione outras propriedades se necessário
  StageId: number
  OrderNumber: number
  PloomesOrderNumber?: number
}

const OrdersTable: React.FC = () => {
  const { user } = useContext(UserContext)
  const {
    quantity,
    setOrderId,
    setOriginDealId,
    setStatus,
    setStatusId,
    setOrderNumber,
  } = useContext(OrdersContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)

  const [loading, setLoading] = useState<boolean>(false)
  const [orders, setOrders] = useState<Order[]>([])

  useEffect(() => {
    const url = process.env.REACT_APP_ORDERS_BASE_URL;
    axios
      .get(`https://ploomes-orders-hjk3p7rq3q-rj.a.run.app/orders-by-ploomes/${user.cnpj}`, {
        params: { quantity: quantity },
      })
      .then((response) => {
        const ordersWithPloomesOrderNumber = response.data.map((data: any) => {
          data.StageName = mappingStage[data.StageId];
          const ploomesOrderNumberMatch = data.Title?.match(/nº da venda: (\d+)/);
          data.PloomesOrderNumber = ploomesOrderNumberMatch ? parseInt(ploomesOrderNumberMatch[1], 10) : null;
          return data;
        });
        setOrders(ordersWithPloomesOrderNumber);
      })
      .catch((error) => {
        console.error('Ocorreu um erro ao obter os dados dos pedidos', error);
      })
  }, [quantity]);

  const handleDetailClick = async (index: number) => {
    setLoading(true);
    try {
      const order = orders[index];
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulação de requisição
      setOrderId(order.Id);
      setOriginDealId(order.OriginDealId);
      setStatus(order.StageName);
      setStatusId(order.StageId);
      setOrderNumber(order.OrderNumber);
      setModalSection('ordersDetails');
      setModalActive(true);
    } catch (error) {
      console.error("Erro ao carregar detalhes do pedido:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleIdClick = (id: number) => {
    window.open(`https://app10.ploomes.com/deal/${id}`, '_blank')
  }

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const TableComponent: React.FC = () => {
    return (
      <GlobalTable>
        <tbody>
          <HeaderLine>
            {shortHeaders.map(header => (<Th key={header}>{header}</Th>))}
          </HeaderLine>
          {orders.map((item, index) => (
            <Tr key={index}>
              {shortFields.map((field, subIndex) => (
                <Td key={subIndex} className={subIndex === 0 ? 'title' : ''}>
                  {field === 'Title' && typeof item[field as keyof Order] === 'string' && (
                    <span title={item[field as keyof Order] as string}>
                      {truncateText(item[field as keyof Order] as string, 32)}
                    </span>
                  )}
                  {field === 'CreateDate' && format(new Date(item.CreateDate), 'dd/MM/yyyy')}
                  {field === 'Amount' && <span>R$ {item.Amount.toFixed(2)}</span>}
                  {field === 'Id' && (
                    <span
                      onClick={() => handleIdClick(item.Id)}
                      style={{ cursor: 'pointer', color: 'blue' }}
                    >
                      {user.cnpj === '03954227000164' ? item.PloomesOrderNumber : item.OrderNumber}
                    </span>
                  )}
                  {field !== 'CreateDate' && field !== 'Amount' && field !== 'Title' && field !== 'Id' && item[field as keyof Order]}
                </Td>
              ))}
              <TdButtons>
                <img 
                  onClick={() => handleDetailClick(index)}
                  src={detailsIcon}
                  alt='Icon to show details'
                />
              </TdButtons>
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
    )
  }

  return (
    <TableComponent />
  )
}

export default OrdersTable
